<template>
	<div class="introductionbox marginbottom">
		<div style="margin:auto auto auto -50px;display: block;text-align: center;margin-right: 40px;">
			<div style="background: url(/images/12.svg) no-repeat;opacity: .08;width: 200px;height: 200px;">
			</div>
			<span
				style="font-size: 40px;color: rgb(0, 121, 133);position: absolute;margin-top: -150px;margin-left: -40px;font-weight: 700;">公司介绍</span>
		</div>
		<img src="../../public/images/shuxian.jpg" alt="">
		<!-- <img src="http://www.yysmart.net/static/img/tit1.159985a3.png" alt=""> -->
		<div class="tabox el-tabs el-tabs--top">
			<div class="el-tabs__header is-top">
				<div class="el-tabs__nav-wrap is-top">
					<div class="el-tabs__nav-scroll">
						<div role="tablist" class="el-tabs__nav is-top" style="transform: translateX(0px);">
							<div class="el-tabs__active-bar is-top" style="width: 80px ;"
								:style="{'transform':'translateX('+(menu.indexOf(active)*134)+'px)'}"></div>
							<div class="el-tabs__item is-top" v-for="item in menu" :class="{'is-active':active===item}"
								@click="active=item">{{item}}</div>
						</div>
					</div>
				</div>
			</div>
			<div class="el-tabs__content">
				<div class="el-tab-pane" v-show="active==='公司简介'">
					<p>
						北京易格通智仿真技术有限公司（以下简称易格）于2014年成立，是一家位于北京上地软件园的高科技公司。易格致力于为全国本科院校、高职高专提供VR虚拟仿真教学软件研发、智慧云仿真教学平台建设、VR实训基地建设等服务。
					</p>
					<p>
						易格秉持“客户第一、服务至上、产品极致”的经营理念，拥有专业的研发与商务团队，利用先进的3D仿真、VR/AR研发技术，使用“硬件平台+资源”三位一体的业务模式，为各院校提供VR实训基地建设+虚拟仿真实验教学平台+资源建设全套解决方案。支持院校完成示范性虚拟仿真实训基地建设，支持国家级示范性虚拟仿真一流课程建设。
					</p>
					<a href="http://wpa.qq.com/msgrd?v=3&uin=3249264630&site=qq" target="_blank" class="entry">
						<i class="el-icon-phone"></i>立即咨询
					</a>
				</div>
				<div class="el-tab-pane" v-show="active==='合作院校'">
					<vue-scrollbar>
						<div style="width: 1100px;">
							<img src="../assets/images/company/本科.jpg" style="height: 380px;">
							<img src="../assets/images/company/专科1.jpg" style="height: 380px;">
							<img src="../assets/images/company/专科2.jpg" style="height: 380px;">
						</div>
					</vue-scrollbar>
					<div class="shade"></div>
				</div>
				<!-- <div class="el-tab-pane" v-show="active==='荣誉资质'">
					<vue-scrollbar>
							<img src="/images/ryzz.jpg" alt="" style="height: 380px;">
					</vue-scrollbar>
				</div> -->
				<!-- <div class="el-tab-pane" v-show="active==='专利情况'">
					<vue-scrollbar>
						<img src="http://www.yysmart.net/static/img/introduction3.61e822ff.png" alt="">
					</vue-scrollbar>
				</div> -->
			</div>
		</div>

	</div>
</template>

<script>
	export default {
		data() {
			return {
				active: '公司简介',
				menu: ['公司简介', '合作院校']
			}
		}
	}
</script>

<style scoped>
	.marginbottom {
		margin-bottom: 100px;
		width: 1280px;
		height: 560px;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
	}

	.introductionbox {
		-webkit-transition: all .3s;
		transition: all .3s;
		height: 560px;
		background: #fff;
		-webkit-box-shadow: 0 19px 93px 40px rgba(105, 124, 167, .13);
		box-shadow: 0 19px 93px 40px rgba(105, 124, 167, .13);
		border-radius: 20px;
		margin: 0 auto;
		position: relative;
		z-index: 2;
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-align: start;
		-ms-flex-align: start;
		align-items: flex-start;
		padding: 60px 90px 70px;
	}

	.introductionbox img {
		margin-right: 20px;
	}

	.introductionbox .tabox {
		width: 850px;
	}

	.introductionbox .tabox .el-tabs__header {
		padding: 0;
		position: relative;
		margin: 0 0 15px;
	}

	.introductionbox .tabox .el-tabs__header .el-tabs__nav-wrap {
		overflow: hidden;
		margin-bottom: -1px;
		position: relative;
	}

	.introductionbox .tabox .el-tabs__header .el-tabs__nav-wrap .el-tabs__nav-scroll {
		overflow: hidden;
	}

	.introductionbox .tabox .el-tabs__header .el-tabs__nav-wrap .el-tabs__nav-scroll .el-tabs__nav {
		white-space: nowrap;
		position: relative;
		-webkit-transition: -webkit-transform .3s;
		transition: -webkit-transform .3s;
		transition: transform .3s;
		transition: transform .3s, -webkit-transform .3s;
		float: left;
		z-index: 2;
	}

	.introductionbox .tabox .el-tabs__header .el-tabs__nav-wrap .el-tabs__nav-scroll .el-tabs__nav .el-tabs__active-bar {
		position: absolute;
		bottom: 0;
		left: 0;
		height: 2px;
		background-color: rgb(0, 121, 133);
		z-index: 1;
		-webkit-transition: -webkit-transform .3s cubic-bezier(.645, .045, .355, 1);
		transition: -webkit-transform .3s cubic-bezier(.645, .045, .355, 1);
		transition: transform .3s cubic-bezier(.645, .045, .355, 1);
		transition: transform .3s cubic-bezier(.645, .045, .355, 1), -webkit-transform .3s cubic-bezier(.645, .045, .355, 1);
		list-style: none;
	}

	.introductionbox .tabox .el-tabs__header .el-tabs__nav-wrap .el-tabs__nav-scroll .el-tabs__nav .el-tabs__item.is-active {
		color: rgb(0, 121, 133);
		font-size: 18px;
		font-weight: 700;
	}

	.introductionbox .tabox .el-tabs__header .el-tabs__nav-wrap .el-tabs__nav-scroll .el-tabs__nav .el-tabs__item {
		padding: 0 35px;
		font-size: 16px;
		color: #767c8e;
		line-height: 26px;
	}

	.introductionbox .tabox .el-tabs__header .el-tabs__nav-wrap .el-tabs__nav-scroll .el-tabs__nav .el-tabs__item:nth-child(2) {
		padding-left: 0;
	}

	.introductionbox .tabox .el-tabs__content {
		overflow: hidden;
		position: relative;
	}
	
	.introductionbox .tabox .el-tabs__content .el-tab-pane {
		overflow-x: auto;
		padding-top: 20px;
	}

	.introductionbox .tabox p {
		line-height: 32px;
		color: #2a3a5c;
		margin-top: 20px;
		text-indent: 2em;
		text-align: justify;
		font-size: 14px;
	}

	.introductionbox .tabox .el-tab-pane {
		overflow-x: auto;
		padding-top: 20px;
	}

	.introductionbox .entry {
		text-decoration: none;
		display: block;
		-webkit-box-pack: center;
		-ms-flex-pack: center;
		justify-content: center;
		-webkit-box-align: center;
		-ms-flex-align: center;
		align-items: center;
		color: #aa5500;
		width: 200px;
		height: 40px;
		line-height: 40px;
		border: 1px solid #aa5500;
		border-radius: 2px;
		line-height: 38px;
		letter-spacing: 2px;
		text-align: center;
		float: right;
		margin-top: 80px;
	}

	.introductionbox .entry img {
		margin-right: 5px;
		vertical-align: text-bottom;
	}
</style>
